import { Dep0301CtlrOut, Dep0301CtlrIn } from 'app/core/models/api/dep/dep0301'
import { Dep0305CtlrOut, Dep0305CtlrIn } from 'app/core/models/api/dep/dep0305'
import {
    Com0102CtlBnnOut,
    Com0102CtlrIn,
} from 'app/core/models/api/com/com0102'
import { Dep0307CtlrOut, Dep0307CtlrIn } from 'app/core/models/api/dep/dep0307'
import { api } from 'app/core/services/base/api.service'
import { CommonResponse } from 'app/core/services/base/response.service'

/**
 * 파일명 : 상품몰 홈 Service API
 * history : 2025-05-19 : 최초작업
 */

let suffixPath = 'prd/dep'
let suffixPath1 = 'prd/com'

export const postApi = api.injectEndpoints({
    endpoints: (build) => ({
        /**
         * 상품목록조회
         */
        selectDep0301: build.query<Dep0301CtlrOut, Dep0301CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/dep03/dep0301`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Dep0301CtlrOut>,
        }),
        /**
         * 보험상세부가정보조회
         */
        selectDep0305: build.query<Dep0305CtlrOut, Dep0305CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/dep03/dep0305`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Dep0305CtlrOut>,
        }),
        /**
         * TODO: com.service -> selectBannerCom0102 쪽으로 이사, 삭제 예정
         */
        selectCom0102: build.query<Com0102CtlBnnOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlBnnOut>,
        }),
        /**
         * 상품금리조회
         */
        selectDep0307: build.query<Dep0307CtlrOut, Dep0307CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/dep03/dep0307`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Dep0307CtlrOut>,
        }),
    }),
})

export const {
    useLazySelectDep0301Query,
    useLazySelectDep0305Query,
    useLazySelectCom0102Query,
    useLazySelectDep0307Query,
} = postApi

export const {
    endpoints: { selectDep0301, selectDep0305, selectCom0102, selectDep0307 },
} = postApi
